import React from 'react'
import Parse from 'html-react-parser'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import * as styles from '~styles/components/editor.module.scss'

const Editor = (props) => {
  return (
    <div className={classNames(styles.editor)}>
      {Parse(props.text)}
    </div>
  )
}

Editor.propTypes = {
  text: PropTypes.string
}

export default Editor
